import {useEffect, useState} from "react"
import { useNavigate } from "react-router-dom"

import "./WebTest.css"
import testBackward from "../../assets/testBackward.svg"
import testReset from "../../assets/testReset.svg"
import arrow from "../../assets/mobilePopupArrow.svg"
import {retrieveData, sendRequest, storeData} from "../../common";

const Answer = ({answer, step, stepIndex, currentIndex, setCurrentIndex, enableTwice, answerReplies, addAnswerReply, clearAll, chapterIndex, steps, isShape}) => {
	const [index, setIndex] = useState(0)
	const [isSelected, setIsSelected] = useState(false)
	const [isSelectedTwice, setIsSelectedTwice] = useState(false)
	const [isApplied, setIsApplied] = useState(false)

	const clearAllData = () => {
		setIndex(0)
		setIsSelected(false)
		setIsSelectedTwice(false)
		setIsApplied(false)

		// if (answerReplies?.findIndex(item => item.answer?.id === answer?.id) !== -1) {
		// 	setIsApplied(true)
		// } else {
		// 	setIsApplied(false)
		// }
	}

	useEffect(() => {
		setIndex(0)
		setIsSelected(false)
		setIsSelectedTwice(false)
		setIsApplied(false)
	}, [answer])

	useEffect(() => {
		// console.log(clearAll)
		if (clearAll) {
			clearAllData()
		}
	}, [clearAll])

	useEffect(() => {
		if (chapterIndex === 4) {
			clearAllData()
		}
	}, [chapterIndex])

	useEffect(() => {
		clearAllData()
	}, [step])

	useEffect(() => {
		const myReplyIdx = answerReplies.findIndex(item => item?.answer?.id === answer?.id)
		if (myReplyIdx !== -1) {
			setIndex(answerReplies[myReplyIdx].index)
			setIsSelectedTwice(answerReplies[myReplyIdx]?.isSelectedTwice)
			if (answerReplies[myReplyIdx].isApplied) {
				setIsApplied(true)
			} else {
				setIsApplied(false)
			}
		} else {
			setIsApplied(false)
			setIsSelected(false)
			setIndex(0)
		}
		if (!answerReplies?.length) {
			clearAllData()
		}

		// if (!isApplied && !answerReplies?.filter(item => !item?.isApplied)?.length) {
		// 	clearAllData()
		// }
	}, [answerReplies])

	// useEffect(() => {
	// 	if (clearAll) {
	// 		if (answerReplies?.findIndex(item => item.answer?.id === answer?.id) !== -1) {
	// 			setIsApplied(true)
	// 		}
	// 	}
	// }, [clearAll])

	return (
		isApplied ?
			<li style={{backgroundColor: '#aaa'}}></li>
			:
		<li
			className={isSelectedTwice ? "step01" : isSelected ? "step02" : ''}
			// style={{backgroundColor: step?.color}}
			onClick={() => {
				if (enableTwice) {
					if (!isSelected) {
						return
					}
					if (isSelectedTwice) {
						return
					}
					if (currentIndex > 3) {
						return
					}
					if (addAnswerReply(answer, currentIndex, stepIndex, chapterIndex)) {
						if (isSelected) {
							setIsSelectedTwice(true)
						}

						setIndex(currentIndex)
						setCurrentIndex(currentIndex + 1)
					}

				} else if (stepIndex >= 2 && isShape) {
					if (currentIndex > 3) {
						return
					}
					if (addAnswerReply(answer, currentIndex, stepIndex, chapterIndex)) {
						setIndex(currentIndex)
						setCurrentIndex(currentIndex + 1)
						setIsSelected(true)
					}
				} else {
					if (index && index < currentIndex) {
						return null
					}
					if (chapterIndex === 3) {
						if (currentIndex > 32) {
							return null
						}
						if (stepIndex === 4 && currentIndex > 18) {
							return null
						}
					}
					if (addAnswerReply(answer, currentIndex, stepIndex, chapterIndex)) {
						setIndex(currentIndex)
						setCurrentIndex(currentIndex + 1)
						if (isSelected) {
							setIsSelectedTwice(true)
						} else {
							setIsSelected(true)
						}
					}
				}

			}}
		>
			{index ? <span>{index}</span> : null}{answer?.name}
		</li>
	)
}

function WebTestConduct() {
	const navigate = useNavigate()

	const [isOpen, setView] = useState(false)
	const toggleView = () => {
		setView((isOpen) => !isOpen)
	}

	const [applyTest, setApplyTest] = useState({})
	const [test, setTest] = useState({})
	const [steps, setSteps] = useState([])
	const [stepIndex, setStepIndex] = useState(0)
	const step = steps ? steps[stepIndex] : {}

	const [chapterIndex, setChapterIndex] = useState(1)

	const [index, setIndex] = useState(1)
	const [enableTwice, setEnableTwice] = useState(false)

	const [answerReplies, setAnswerReplies] = useState([])
	const [clearAll, setClearAll] = useState(false)

	const [loading, setLoading] = useState(false)
	const isShape = test?.name?.indexOf('도형심리') !== -1


	const addAnswerReply = (answer, index, stepIndex, chapterIndex) => {

		const duplicateCheck = (answer) => {
			return answerReplies.findIndex(item => item?.answer?.id === answer?.id) !== -1
		}

		if (chapterIndex === 1) {
			if (isShape) {
				if (stepIndex < 2 && answerReplies?.length >= 10) {
					return false
				}
			} else {
				if (stepIndex < 4 && answerReplies?.length >= 10) {
					return false
				} else if (stepIndex === 4 && answerReplies?.length >= 6) {
					return false
				}
			}
		}

		if (chapterIndex === 3) {
			const answer_ = {
				answer,
				index: step?.answers?.length - (index - step?.answers?.length),
				stepIndex,
				chapterIndex
			}
			if(duplicateCheck(answer_)) {
				alert('중복된 답변이 존재합니다. 웹페이지 리프레쉬 후 다시 진행을 부탁드립니다.')
				return
			}
			answerReplies.push(answer_)
			setAnswerReplies(Object.assign([], answerReplies))
			return true
		}

		const prevIndex = answerReplies.findIndex(item => item.answer?.id === answer?.id)
		if (prevIndex !== -1 && !(isShape && stepIndex >= 2)) {
			// console.log(index)
			// console.log(answerReplies[prevIndex].index)
			const newList = answerReplies.map(item => {
				if (answer?.id === item?.answer?.id) {
					return {
						...item,
						index,
						isSelectedTwice: true
					}
				} else if (item?.index <= answerReplies[prevIndex].index && !item?.isSelectedTwice) {
					return {
						...item,
						index: item?.index + 1
					}
				} else {
					return item
				}
			})
			setAnswerReplies(Object.assign([], newList))
			return true
		} else {
			if (prevIndex !== -1) return false
			// alert(prevIndex)
			const answer_ = {
				answer,
				index,
				stepIndex,
				chapterIndex,
				chapter1Index: chapterIndex === 1 ? index : null
			}
			if(duplicateCheck(answer_)) {
				alert('중복된 답변이 존재합니다. 웹페이지 리프레쉬 후 다시 진행을 부탁드립니다.')
				return
			}
			answerReplies.push(answer_)
			setAnswerReplies(answerReplies)
			return true
		}
		return false
	}


	useEffect(() => {
		retrieveData('test').then(test => {
			setTest(test)
			setSteps(test?.steps)
		})
		retrieveData('applyTest').then(applyTest => {
			setApplyTest(applyTest)
		})
		storeData('startTime', new Date().getTime())
	}, [])

	const clearAllData = () => {
		setClearAll(true)
		setAnswerReplies([])
		setIndex(1)
		setEnableTwice(false)
	}

	const getAnswerResult = (number) => {
		const idx = answerReplies.findIndex(item => item.index === number)
		if (idx !== -1) {
			return (
				<li className="active">{answerReplies[idx]?.answer?.name}</li>
			)
		} else {
			return (
				<li>{number}</li>
			)
		}
	}

	let isLoading = false
	const saveAnswerReply = (replies) => {
		sendRequest('test/answer-replies/', 'POST', {
			answerReplies: replies,
			applyTest: applyTest?.id,
			step: steps[stepIndex]?.id
		}, data => {
			if (stepIndex === steps?.length - 1) {
				window.history.replaceState(null, null, "/");
				navigate('/complete-test')
			}
			isLoading = false
		}, (data, code) => {
			window.location.reload();
			alert(data?.msg)
		})
	}

	const saveAllAnswerReply = () => {
		if (isLoading) return
		isLoading = true
		if (stepIndex === steps?.length - 1) {
			if (window.confirm('최종 제출 하시겠습니까?')) {
				saveAnswerReply(answerReplies)
			}
		} else {
			saveAnswerReply(answerReplies)
		}
	}

	const retry = () => {
		if (chapterIndex === 1) {
			clearThisStep(chapterIndex)
		} else if (chapterIndex === 2) {
			const newList = answerReplies.map(item => {
				return {
					...item,
					isSelectedTwice: false,
					index: item?.chapter1Index
				}
			})
			setAnswerReplies(Object.assign([], newList))
			setIndex(1)
		} else if (chapterIndex === 3) {
			clearThisStep(chapterIndex)
		} else if (chapterIndex === 4) {
			clearThisStep(chapterIndex)
		}
	}

	const getColorClass = (stepIndex) => {
		if (isShape) {
			switch (stepIndex) {
				case 0:
					return 'green'
				case 1:
					return 'orange'
				case 2:
					return 'green'
				case 3:
					return 'orange'
			}
		} else {
			switch (stepIndex) {
				case 0:
					return 'green'
				case 1:
					return 'purple'
				case 2:
					return 'skyBlue'
				case 3:
					return 'orange'
				case 4:
					return 'pink'
			}
		}
	}

	const clearThisStep = (chapterIndex) => {
		const newList = answerReplies.filter(item => {
			return item.chapterIndex !== chapterIndex
		})
		setAnswerReplies(Object.assign([], newList))
		if (chapterIndex === 1) {
			setIndex(newList?.length + 1)
		} else if (chapterIndex === 3) {
			setIndex(step?.answers?.length)
		} else if (chapterIndex === 4) {
			setIndex(newList?.length + 1 - 3)
		}
	}

	// console.log(answerReplies)

	return (
		<>
			<div className={`testContainer ${getColorClass(stepIndex)}`}>
				<div className="headerWrap">
					<div className="header">
						<div className="title">
							<span className="category" style={{backgroundColor: step?.color}}>{stepIndex + 1}. {step?.name}</span>
							<span className="pagination">
								<b>{stepIndex + 1}</b>&#47;{steps?.length}
							</span>
						</div>
						{chapterIndex < 3 ?
							isShape && stepIndex > 1 ?
								<h2>지금 현재 <b>직장이나 학교에서의 ‘내 모습’</b>을 잘 표현하는 단어 3개를 고르세요. </h2>
							:
							enableTwice ?
								stepIndex < 4 ?
									<h2>
										Q. <b>선택한 단어</b> 중 자신에게 <b>더 편안한 단어</b> 3개를 <b>순서대로</b> 고르세요.
										{/*Q. 본인이 <b>선택한 단어</b> 중 <b>더 편안하게</b> 느껴지는 단어 3개를 <b>순서대로</b> 고르세요.*/}
									</h2>
									:
									<h2>
										Q. <b>선택한 단어</b> 중 <b>현재 자신의 상태</b>에 더 <b>가까운 단어</b> 3개를 <b>순서대로</b> 고르세요.
										{/*Q. 본인이 <b>선택한 단어</b> 중 <b>더 편안하게</b> 느껴지는 단어 3개를 <b>순서대로</b> 고르세요.*/}
									</h2>
								:
								stepIndex < 4 ?
								<h2>
									Q. 자신에게 <b>편안한 단어</b> 10개를 고르세요.
									{/*Q. 자신에게 <b>편안한 단어</b>를 <b>순서대로 10개 이내</b> 고르세요.*/}
									{/*Q. 자신에게 <b>편안하게</b> 느껴지는 단어를 고르세요. <span>(최소 3개 이상)</span>*/}
								</h2>
								:
								<h2>
									Q. <b>현재 자신의 상태</b>를 나타내는 <b>단어</b> 6개를 고르세요.
									{/*Q. <b>현재 자신의 상태</b>를 나타내는 <b>단어</b>를 <b>순서대로 6개 이내</b> 고르세요.*/}
									{/*Q. 자신에게 <b>편안하게</b> 느껴지는 단어를 고르세요. <span>(최소 3개 이상)</span>*/}
								</h2>
								:
							chapterIndex === 3 ?
								stepIndex < 4 ?
									<h2>
										Q. <b>남은 단어</b>에서 자신에게 <b>가장 불편한 단어</b> 3개를 <b>순서대로</b> 고르세요.
										{/*Q. 남은 단어에서 <b>가장 불편하게</b> 느껴지는 단어 3개를 고르세요.*/}
									</h2>
									:
									<h2>
										Q. <b>남은 단어</b>에서 <b>현재 자신의 상태</b>와 <b>가장 먼 단어</b> 3개를 고르세요.
										{/*Q. 남은 단어에서 <b>가장 불편하게</b> 느껴지는 단어 3개를 고르세요.*/}
									</h2>
								:
								stepIndex < 4 ?
									<h2>
										Q. <b>남은 단어</b> 중에서 자신에게 <b>편안하게 느껴지는 단어</b>를 <b>순서대로</b> 고르세요.
										{/*Q. 남은 단어에서 <b>그래도 편안하게</b> 느껴지는 순서대로 단어를 <b>전부</b> 고르세요.*/}
									</h2>
									:
									<h2>
										Q. <b>남은 단어</b> 중에서 <b>자신의 상태</b>에 <b>가깝게 느껴지는 단어</b>를 <b>순서대로</b> 고르세요.
										{/*Q. 남은 단어에서 <b>그래도 편안하게</b> 느껴지는 순서대로 단어를 <b>전부</b> 고르세요.*/}
									</h2>
							}
					</div>
				</div>
				<div className="testConduct">
					<section className="conductLt">
						<div className="btnWrap">
							<button type="button" onClick={() => {
								retry()
							}}>
								<img src={testBackward} alt="다시선택" /> 다시선택
							</button>
							<button type="button" onClick={() => {
								clearAllData()
								setChapterIndex(1)
							}}>
								<img src={testReset} alt="초기화" /> 초기화
							</button>
						</div>
						<ul className="question">
							{step?.answers?.map((answer, idx) => {
								return (
									<Answer
										answer={answer}
										step={step}
										stepIndex={stepIndex}
										currentIndex={index}
										setCurrentIndex={setIndex}
										enableTwice={enableTwice}
										answerReplies={answerReplies}
										addAnswerReply={addAnswerReply}
										chapterIndex={chapterIndex}
										clearAll={clearAll}
										steps={steps}
										isShape={isShape}
									/>
								)
							})}
						</ul>
						<button
							type="button"
							className="keyBtn"
							style={{opacity: loading ? 0.5 : 1}}
							onClick={() => {
								setLoading(true)
								setTimeout(() => setLoading(false), 100)
								if (isShape && (stepIndex >= 2)) {
									if (answerReplies?.length < 3) {
										alert('지금 현재 직장이나 학교에서의 내 모습을 잘 표현하는 단어 3개를 선택해 주세요.')
										return
									}
									saveAllAnswerReply()
									clearAllData()
									if (stepIndex === 2) {
										setStepIndex(stepIndex + 1)
									}

								} else {
									if (chapterIndex === 1 && answerReplies?.length < (stepIndex < 4 ? 10 : 6)) {
										alert(`${stepIndex < 4 ? '10' : '6'}개를 선택해주세요.`)
										return
									}

									if (chapterIndex === 2 && answerReplies.filter(item => item?.isSelectedTwice)?.length < 3) {
										alert('선택한 단어 중에 3개를 선택해주세요.')
										return
									}

									if (chapterIndex === 3 && answerReplies?.filter(item => item?.index > step?.answers?.length - 3)?.length < 3) {
										if (stepIndex < 4) {
											alert('가장 불편한 단어 3개를 선택해주세요.')
										} else {
											alert('내 상태와 가장 먼 단어 3개를 선택해주세요.')
										}
										return
									}

									if (chapterIndex === 4) {
										if (step?.answers?.length !== answerReplies?.length) {
											alert('모두 선택해 주세요.')
											return
										}

										saveAllAnswerReply()
										if (stepIndex === steps?.length - 1) {
											return
										}
									}

									if (enableTwice) {
										if (chapterIndex === 2) {
											// alert('chapter 2')
											const newList = answerReplies.map(item => {
												return {
													...item,
													isApplied: true
												}
											})
											setAnswerReplies(newList)

											setClearAll(true)
											setIndex(step?.answers?.length)
										} else {
											setClearAll(false)
										}
										setChapterIndex(chapterIndex + 1)
										setEnableTwice(false)
									} else {
										if (chapterIndex === 4) {
											if (step?.answers?.length !== answerReplies?.length) {
												alert('모두 선택해 주세요.')
												return
											}
											clearAllData()
											setStepIndex(stepIndex + 1)
											setChapterIndex(1)
										} else if (chapterIndex === 3) {
											const newList = answerReplies.map(item => {
												return {
													...item,
													isApplied: true
												}
											})
											setAnswerReplies(newList)

											setIndex(answerReplies?.length + 1 - 3)
											setChapterIndex(chapterIndex + 1)
										} else {
											setIndex(1)
											if (chapterIndex === 1) {
												setEnableTwice(true)
											}
											setChapterIndex(chapterIndex + 1)
										}
									}
									setClearAll(false)
									// navigate("/complete-test")
								}
							}}
						>
							{`다음 (${chapterIndex}단계)`}
						</button>
						<div style={{marginBottom: 300}}></div>
					</section>
					<section className={isOpen ? "conductRt open" : "conductRt"}>
						<div className="bg"></div>
						<div className="viewWrap">
							<div className="viewHeader" onClick={toggleView}>
								<h3>결과 미리보기</h3>
								<div className="more">
									<img src={arrow} alt="더보기 버튼" />
								</div>
							</div>
							{stepIndex !== 4 ?
								<ul className="view">
									<div className="primary">
										{getAnswerResult(1)}
									</div>
									<div className="primary">
										{getAnswerResult(2)}
										{getAnswerResult(3)}
									</div>
									<div>
										{getAnswerResult(4)}
										{getAnswerResult(5)}
										{getAnswerResult(6)}
									</div>
									<div>
										{getAnswerResult(7)}
										{getAnswerResult(8)}
										{getAnswerResult(9)}
										{getAnswerResult(10)}
									</div>
									<div>
										{getAnswerResult(11)}
										{getAnswerResult(12)}
										{getAnswerResult(13)}
										{getAnswerResult(14)}
										{getAnswerResult(15)}
									</div>
									<div>
										{getAnswerResult(16)}
										{getAnswerResult(17)}
										{getAnswerResult(18)}
										{getAnswerResult(19)}
										{getAnswerResult(20)}
									</div>
									<div>
										{getAnswerResult(21)}
										{getAnswerResult(22)}
										{getAnswerResult(23)}
										{getAnswerResult(24)}
									</div>
									<div>
										{getAnswerResult(25)}
										{getAnswerResult(26)}
										{getAnswerResult(27)}
									</div>
									<div className="primary">
										{getAnswerResult(28)}
										{getAnswerResult(29)}
									</div>
									<div className="primary">
										{getAnswerResult(30)}
									</div>
								</ul>
								:
								<ul className="view smallView">
									<div className="primary">
										{getAnswerResult(1)}
									</div>
									<div className="primary">
										{getAnswerResult(2)}
										{getAnswerResult(3)}
									</div>
									<div>
										{getAnswerResult(4)}
										{getAnswerResult(5)}
										{getAnswerResult(6)}
									</div>
									<div>
										{getAnswerResult(7)}
										{getAnswerResult(8)}
										{getAnswerResult(9)}
										{getAnswerResult(10)}
									</div>
									<div>
										{getAnswerResult(11)}
										{getAnswerResult(12)}
										{getAnswerResult(13)}
									</div>
									<div>
										{getAnswerResult(14)}
										{getAnswerResult(15)}
									</div>
									<div>
										{getAnswerResult(16)}
									</div>
								</ul>
							}
						</div>
					</section>
				</div>
			</div>
		</>
	)
}

export default WebTestConduct
